import { FoodsIllustrations, HelperBox, WhiteBox } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { Navigate } from "react-router-dom";
import { Loading } from "src/components/utils/Loading";

type EmptySynthesisProps = unknown;
export const ActionPlanInit = (_props: EmptySynthesisProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { actionPlan, urls, savingStatus, elligibleStartingPosts, setOpenInitForm } = useActionsContext();

    if (actionPlan !== null) {
        // What are you doing here, sneaky ;)
        <Navigate to={urls.planning()} replace />;
    }

    const isLoading = elligibleStartingPosts === undefined;
    const cantBeCreated = elligibleStartingPosts?.length === 0;
    return (
        <WhiteBox>
            <Stack
                flexDirection={"column"}
                padding={theme.spacing(4, 8)}
                gap={theme.spacing(2)}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Fragment>
                    <FoodsIllustrations illustration={"underConstruction"} />
                    <Typography variant="body-medium">{t("actionPlan.trajectory.noTrajectory.info")}</Typography>
                    {isLoading ?
                        <Loading />
                    : cantBeCreated === true ?
                        <HelperBox>
                            <Typography variant={"body-bold"}>{t("actionPlan.noLockedSsq")}</Typography>
                        </HelperBox>
                    :   <Button
                            variant="primary"
                            onClick={() => {
                                setOpenInitForm(true);
                            }}
                        >
                            {t("actionPlan.trajectory.noTrajectory.button")}
                        </Button>
                    }
                </Fragment>
            </Stack>
        </WhiteBox>
    );
};
